import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getValuesFromLocalstorage } from '../../Helpers';
import { typeOfApplication } from '../../../Constants/index.js';
import LOCAL_KEYS from '../../../helpers/localstorage';
 
const ProtectedRoute = () => {
  const location = useLocation();
  const userDetails = getValuesFromLocalstorage(LOCAL_KEYS.USER_DETAILS);
  const isPasswordExpired = getValuesFromLocalstorage(LOCAL_KEYS.PASSWORD_EXPIRED);
  
  console.log("Protected route check:", {
    userDetails,
    typeOfApplication,
    isPasswordExpired,
    pathname: location.pathname
  });
  
  // Allow ADMIN, MKTG_EXEC (marketing executive), and RECRUITER users to access protected routes
  const isValidUser = userDetails && (userDetails.acctType === typeOfApplication || userDetails.acctType === "MKTG_EXEC" || userDetails.acctType === "RECRUITER");
  
  // If not a valid user, redirect to login
  if (!isValidUser) {
    return <Navigate to="/login" />;
  }
  
  // If password is expired and user is not on updatePassword page, redirect there
  if (isPasswordExpired && location.pathname !== "/updatePassword") {
    return <Navigate to="/updatePassword" />;
  }
  
  // If valid user and password not expired (or on password update page), allow access
  return <Outlet />;
};
  
export default ProtectedRoute;
 